"use client";

import { type SyntheticEvent, useEffect, useMemo, useState } from "react";

import { Modal } from "antd";
import { ospThemes } from "../ospThemes";
import { Icon } from "../Icon";
import type { OspModalType } from "./types";
import { useStyles } from "./styles";
import { cn } from "utils";

export const OspModal = (props: OspModalType) => {
	const {
		children,
		containerStyle,
		containerClassName,
		contentStyle,
		showClose = true,
		onClose,
		centered = true,
		closeStyle,
		closeIconSize = 16,
		closeIconClassName,
		title,
		titleClassName,
		titleStyle,
		...otherProps
	} = props;
	const [visable, setVisable] = useState(!!props.open);
	const { styles, cx } = useStyles();
	const mousePosition = useMemo(() => {
		//client only
		if (typeof document === "undefined") { return }
		if (!centered || !document?.documentElement?.clientWidth) {
			return undefined
		}
		const width = document.documentElement.clientWidth;
		const height = document.documentElement.clientHeight;
		return {
			x: width / 2,
			y: height / 2,
		};
	}, [centered]);
	useEffect(() => {
		setVisable(!!props.open);
	}, [props.open]);
	return (
		<Modal
			centered={centered}
			{...otherProps}
			footer={null}
			open={visable}
			closeIcon={null}
			mousePosition={mousePosition}
			rootClassName={cx(styles.container)}
			styles={{
				body: {
					padding: 0,
					...otherProps.styles?.body,
				},
				wrapper: {
					zIndex: 999,
					...otherProps.styles?.wrapper,
				},
				content: {
					padding: 24,
					width: "fit-content",
					borderRadius: 16,
					backgroundColor: ospThemes.colors.background_solid_secondary,
					...contentStyle,
					...otherProps.styles?.content,
				},
				mask: {
					backgroundColor: ospThemes.colors.background_clearcover,
					zIndex: 999,
					...otherProps.styles?.mask,
				},
			}}
			modalRender={(modal) => <div>{modal}</div>}
		>
			<div style={{ ...containerStyle, position: "relative" }} className={cx(styles.baseContainer, containerClassName)}>
				<div
					style={{
						...titleStyle,
						display: title ? "block" : "none",
					}}
					className={cx(styles.titleContainer, titleClassName)}
				>
					{title}
					{
						showClose && (
							<span
								style={{ position: "absolute", top: 0, right: 0, zIndex: 100, cursor: 'pointer', display:'flex', ...closeStyle }}
								onClick={(e: SyntheticEvent) => {
									setVisable((visable) => !visable);
									onClose?.(e);
								}}
							>
								<Icon name="close" size={closeIconSize} className={cn('text-content_primary hover:text-content_secondary w-6 h-6', closeIconClassName || '')}/>
							</span>
						)
					}
				</div>
				{children}
			</div>
		</Modal>
	);
};